import { AxiosInstance } from 'axios';

//because the lib needs to reference axios instances and mobile and web implement their own axios instances,
//we need to explicitly set them where theyre defined:
//on web: src\asyncHelpers\index.ts

let libApiInstance: AxiosInstance;
let libPublicApiInstance: AxiosInstance;
let libAuthInstance: AxiosInstance;
let authClientId: string;

export function setApiAxiosInstance(newInstance: AxiosInstance) {
    libApiInstance = newInstance;
}

export function setPublicApiAxiosInstance(newInstance: AxiosInstance) {
    libPublicApiInstance = newInstance;
}

export function setAuthAxiosInstance(newInstance: AxiosInstance) {
    libAuthInstance = newInstance;
}

export function setAuthClientId(newClientId: string) {
    authClientId = newClientId;
}

export { authClientId, libApiInstance, libAuthInstance, libPublicApiInstance };
